export const APP_HEADER_HEIGHT = '64px'
export const SUB_HEADER_HEIGHT = '64px'
export const HEADER_HEIGHT = '128px'

export const REACT_SORTABLE_TREE_STYLES = {
  outline: 'none',
  paddingTop: '8px'
}
